import { DataTableComponent } from "../datatable.component";
import { Input, forwardRef, Inject, Component } from "@angular/core";
import { Column } from "primeng/primeng";

@Component({
  selector: "[pTableBody]",
  templateUrl: "./tablebody.component.html"
})
export class TableBodyComponent {
  constructor(
    @Inject(forwardRef(() => DataTableComponent)) public dt: DataTableComponent
  ) {}

  @Input("pTableBody") columns: Column[];

  @Input() data: any[];

  visibleColumns() {
    return this.columns ? this.columns.filter(c => !c.hidden) : [];
  }
}
